import React from 'react';
import camelCase from 'lodash/camelCase';

// Helpers
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Utils
import { generateHeaderForQuestion } from 'Shared/utils/Reviews.utils';

// Components
import { WpGif } from 'Wpds/components/gif';
import PrivateQuestionPopover from './PrivateQuestionPopover';
import QuestionLeftUnanswered from './QuestionLeftUnanswered';

// Styles
import './GifQuestionReview.scss';

type Props = {
  question;
  answers;
  alternateKey?: string;
  slimVersion?: boolean;
};

const GifQuestionReview = ({ question, answers, alternateKey, slimVersion = false }: Props) => {
  const questionKey = ReviewFormTemplatesHelpers.getQuestionKey(question);
  const showBadge = ReviewFormTemplatesHelpers.getQuestionPrivate(question);

  const key = alternateKey || questionKey;

  // the schema normalizer converts all object keys to camel case,
  // including the question keys. if the snake case key doesn't return results
  // check to see if the key is camel case.
  const answersToQuestions = answers[key] || answers[camelCase(key)];

  const url = answersToQuestions?.gif_url || answersToQuestions?.gifUrl;
  const baseClassName = 'GifQuestionReview';
  return (
    <div className={baseClassName}>
      {!slimVersion && (
        <div className={`${baseClassName}__property`}>
          {generateHeaderForQuestion({ question })}
          {showBadge && <PrivateQuestionPopover />}
        </div>
      )}
      {url ? (
        <div className={`${baseClassName}__gif`}>
          <WpGif url={url} />
        </div>
      ) : (
        <QuestionLeftUnanswered />
      )}
    </div>
  );
};

export default GifQuestionReview;
